// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__4nV-7","textarea":"styles_textarea__3EVZX"};